var $ = jQuery.noConflict();

$(document).ready(function() {
  //console.log('ready');

  $(".t-entry-category a[href$='mis_en_avant/mettre-en-avant/']").hide();

  function hideEmptyHeader() {
    let headerDescription = $('#page-header .header-wrapper .vc_row:last-child');
    if ($('#page-header .header-wrapper .vc_row:last-child .uncont').hasClass('no-block-padding')) {
      headerDescription.hide();
    }
  }
  hideEmptyHeader();
});
